import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { HybridRegionTileFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: HybridRegionTileFragment;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function HybridRegionTile({ fragment, children, dispatch }: Props) {
  const { t } = useTranslation();

  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile
      fragment={fragment}
      preview={fragment.attributes
        .map((attr) => t(`HybridRegionTile.preview.${attr.__typename}`))
        .join(", ")}
      onClick={onClick}
    >
      {children}
    </RegionTile>
  );
}
